export default __webpack_public_path__ + "locales/hy-AM/SendInviteDialog.json?hash=e82109c01dd105dc29d376c948fc6de1";